import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import UserNameRequirementsText from '@/ui/shared/UsernameRequirementsText.vue';
import PasswordRequirementsText from '@/ui/shared/PasswordRequirementsText.vue';
import ICreateUsernamePasswordForm from './createusernamepasswordform.interface';
import { useTranslations } from '@/core/translate.mixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateUsernamePasswordForm',
  props: {
    usernameText: null,
    passwordText: null,
    confirmPasswordText: null,
    submitButtonText: null,
    showSpinner: { type: Boolean },
    errorMessage: null,
    userNameError: { type: Boolean },
    formTitle: null,
    formDescription: null,
    passwordValidationText: null
  },
  emits: ['submit'],
  setup(__props: any, { emit }) {

const props = __props as {
    usernameText: string;
    passwordText: string;
    confirmPasswordText: string;
    submitButtonText: string;
    showSpinner: boolean;
    errorMessage: string;userNameError: boolean;
    formTitle: string;
    formDescription: string;
    passwordValidationText: string;
}

const formData = ref<ICreateUsernamePasswordForm>({
    username: '',
    password: '',
    confirmPassword: ''
});



const customUsernameError = ref<string>('');
watch(() => formData.value.username, () => {
    customUsernameError.value = '';
});
watch(() => props.userNameError, (value) => {
    customUsernameError.value = value ? t('Pages.PartnerPortal.Login.CreateUsernamePasswordPage.UsernameInvalidMessage') : '';
});

const { t } = useTranslations();


const onSubmit = () => emit('submit', formData.value);

return { __sfc: true,formData, props, customUsernameError, t, emit, onSubmit, UserNameRequirementsText, PasswordRequirementsText }
}

})